
/* injects from baggage-loader */

export const onca_apresentation = [
    `Olá, eu sou a <b>onça-pintada</b>!`,
    `Meu nome científico é <b>Panthera Onça</b>, e sou encontrada em <b>florestas tropicais</b> e <b>subtropicais</b>, incluindo ainda <b>cerrado, caatinga e pantanal</b>.`,
    `<b>Movimento-me com astúcia</b> na mata, de preferência <b>à noite</b>, quando saio <b>para caçar</b> outros mamíferos.`,
    `Minhas garras são afiadas e meus movimentos, silenciosos.`,
    `Infelizmente, estou <b>ameaçada de extinção</b>. No Brasil, <b>a Amazônia</b> é uma das últimas regiões que há área <b>não invadida</b> pelos <b>caçadores</b>.`,
];

export const peixeboi_apresentation = [
    `Olá, eu sou o <b>peixe-boi</b>!`,
    `Meu nome científico é <b>Trichechus Inunguis</b>, e sou encontrado em <b>rios e lagos</b> associados, sob qualquer correnteza.`,
];

export const tamandua_apresentation = [
    `Olá, eu sou o <b>tamanduá-bandeira</b>!`,
    `<b>Myrmecophaga Tridactyla</b>, é meu nome científico, e sou encontrado em <b>florestas, savanas e cerrados</b> das <b>Américas do sul e Central</b>.`,
    `Eu me alimento de <b>formigas</b> e <b>larvas</b>. Apesar de ser quase cego, tenho um olfato muito desenvolvido.`,
    `Quando encontro um formigueiro, cavo a terra com minhas fortes garras e minha língua pegajosa para pegar as formiguinhas.`,
    `Infelizmente, estou <b>ameaçado de extinção</b> devido às <b>queimadas</b> e os <b>caçadores</b>.`
];

export const macaco_apresentation = [
    `Olá, eu sou o <b>macaco-barrigudo</b>!`,
    `Meu nome científico é <b>Lagotrix Lagothricha</b>, e sou encontrado nas <b>florestas</b>.`,
    `Me desloco com <b>grande rapidez</b> e <b>posso dar saltos</b> de uma árvore para outra com bastante <b>agilidade e facilidade</b>.`,
    `Enquanto colho as <b>folhas e frutos</b> para me alimentar, fico <b>pendurado pela cauda</b> nos galhos.`,
    `Infelizmente, estou <b>ameaçado de extinção</b> devido à <b>destruição do meu habitat</b> e ao <b>tráfico de animais</b> da minha espécie.`
];

export const html_daily_board = `
    <div class="subtitle">
        Sua missão é ajudar a salvar alguns animais em extinção!    
        <div class='stripe-dotted'></div> <div class='margin-lg-botton'> Clique em uma das placas para começar.<br>
        Sua evolução será gravada no </div>
        <div class='label-daily'></div> 
    </div>
`


// WEBPACK FOOTER //
// ./src/app/pages/main/main.const.js